var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangle = function SvgAlertTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M7 5.25v2.333m0 2.334h.006M6.192 2.27l-4.798 8.287c-.266.46-.399.69-.38.878a.58.58 0 0 0 .238.412c.153.111.419.111.95.111h9.596c.53 0 .796 0 .95-.111a.58.58 0 0 0 .237-.412c.02-.188-.113-.418-.38-.878L7.808 2.27c-.266-.458-.398-.687-.571-.764a.58.58 0 0 0-.474 0c-.173.077-.306.306-.57.764"
  })));
};
export default SvgAlertTriangle;